import { UnitsState, UnitsStateModel } from './units.state';
import { Selector } from '@ngxs/store';

export class UnitsSelectors {
  @Selector([UnitsState])
  static getUnitData(state: UnitsStateModel) {
      return state;
  }
}
